module.exports = __webpack_public_path__ + "static/icon-pledge-2-62b47ee6a371c3d6d3ae4471f3308aca.svg";